<div id="managePopUp">
    <div class="modal-header">
        <span class='modal-title' *ngIf="header">{{header}}</span>
    </div>
    <div class="modal-body">
        <p class="message"> {{body}}</p>

        <div class="row row-style">
            <div class="col-7">{{authoringContentData?.manageLine?.lineHeaderText}}     
            </div>
            <div class="col-5">{{authoringContentData?.manageLine?.restrictionHeaderText}}
            </div>
        </div>

        <div class="row row-style" *ngFor="let line of selectedLines">
            <div class="col-1">
                <mat-checkbox (change)="updateSelection($event, line)"
                [(ngModel)]="line.isSelected"></mat-checkbox> 
            </div>
            <div class="col-6">{{line.msisdn}}     
            </div>
            <div class="col-5" *ngIf=!simToDeviceLock>{{action === 'simProtection' ? line.simProtectionRestrictionStatus : line.portOutRestrictionStatus}}
            </div>
            <div class="col-5" *ngIf=simToDeviceLock>{{ line.simLockUnlockRestrictionStatus}}
            </div>
        </div>

        <div class="row footer-style">
            <div class="footer-message">    
                <p class="message"> {{footer}}</p>
             </div>
         
            <div class='btn-on-off' *ngIf=!isActionChangeSim>
                <button type='button' class="col-style w-50" (click)="onClickAction(true)" [ngClass]="{'active-on': isActionOn === true}">{{actionOn}}</button>
                <button class='btn-border w-50' type='button' (click)="onClickAction(false)" [ngClass]="{'active-off': isActionOn === false}">{{actionOff}}</button>
            </div>

        </div>

    <div class="modal-footer pull-right popup_btnbox bottom_aligner">
        <div class='btnFullWidth'>
            <button type='button' class='secondary_btn'
                (click)="onClickCancel()"  *ngIf="ctaCancel">{{ctaCancel}}</button>
        </div>
        <div class='btnFullWidth'>
            <button type='button' class='primary_btn' [disabled] = "!isSubmitEnabled"
                (click)="onClickSubmit()">{{ctaSubmit}}</button>
        </div>
    </div>

</div>